import { ntxAPI } from '@API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

// ==============================
// Types
// ==============================
export type ItemsWithUomQueryParams = {
  PriceListId?: string; // query
  Scope?: number; // query
  InventoryId?: string; // query (required)
  WithParent?: boolean; // query
  WithImage?: boolean; // query
  WithLots?: boolean; // query
  OnlyEnabled?: boolean; // query
  WithLastPrice?: boolean; // query
};

export type ItemsWithUomBody = {
  pageIndex: number; // 1-based
  pageSize: number;

  itemCode?: string;
  name?: string;
  barcode?: string;

  categoryId?: string;
  unitOfMeasure?: string;
  brandId?: string;

  itemType?: string;

  purchasingEnabledFlag?: boolean;
  customerOrderEnabledFlag?: boolean;

  itemIds?: string[];
};

export type QtyByLotRow = {
  lotNumber: string;
  expirationDate: string | null;
  reservationQty: number | null;
  qty: number | null;
  lotId: string | null;
};

export type ItemWithUomRow = {
  id: string | null;
  itemId: string;
  categoryId: string | null;

  name: string | null;
  name2: string | null;

  barcode: string | null;
  itemCode: string | null;

  isPrimaryUOM: boolean;

  unitOfMeasure: string;
  unitOfMeasureName: string | null;
  unitOfMeasureName2: string | null;

  tax: any;
  itemVat_Rate: number | null;

  // costPrice: number | null;
  lastCostPrice: number | null;
  quentity: number | null;
  reservedQty: number | null;
  unitPrice: number | null;

  enabledFlag: boolean;
  isParent: boolean;

  image: string | null;

  uomFactor: number | null;

  qtyByLot?: QtyByLotRow[]; // يظهر عند WithLots=true
};

export type PagedResponse<T> = {
  totalItems: number;
  data: T[];
  pageIndex: number; // 1-based
  pageSize: number;
};

// ==============================
// API
// ==============================
export async function fetchItemsWithUomLookup(
  params: ItemsWithUomQueryParams,
  body: ItemsWithUomBody,
  signal?: AbortSignal
) {
  const res = await ntxAPI.post<APIResponse<PagedResponse<ItemWithUomRow>>>(`Inv/GetItemsWithUomLookup`, body, {
    params,
    signal
  });
  return res.data;
}
